import * as App from '../../app';
import * as Backend from '../../backend-api';
import { DailyBonusModal } from '../../modals';
export function dailyBonusModal() {
    var dailyBonusModal = new DailyBonusModal({
        onOpen: function () {
            App.stat.params({ dailyBonus: { open: 1 } });
        },
        onGetCoins: function (coins) {
            Backend.getDailyBonus(coins)
                .then(function (res) {
                App.Fn.updateCoins(res.balance);
                setTimeout(saveDailyBonusOnWebAppStorage, 1000);
            })
                .catch(function () {
                App.stat.params({ dailyBonus: { error: 1 } });
            });
            App.stat.params({ dailyBonus: { getCoins: 1 } });
        },
        onClose: function () {
            App.stat.params({ dailyBonus: { close: 1 } });
        },
    });
    return dailyBonusModal;
}
function saveDailyBonusOnWebAppStorage() {
    var _a = App.storage.get(), dailyBonusHistory = _a.dailyBonusHistory, dailyBonusReceivedDay = _a.dailyBonusReceivedDay;
    App.Fn.vkWebAppStorageSet('dailyBonus', [dailyBonusHistory, dailyBonusReceivedDay]);
}
